import { render } from "./testCountryJson.vue?vue&type=template&id=4e87b073&scoped=true"
import script from "./testCountryJson.vue?vue&type=script&lang=js"
export * from "./testCountryJson.vue?vue&type=script&lang=js"

import "./testCountryJson.vue?vue&type=style&index=0&id=4e87b073&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e87b073"]])

export default __exports__